import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { FaShoppingBasket, FaHeart } from "react-icons/fa";
import { Grid, makeStyles, Button, Box } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import { backend } from "../../../api";
import { Skeleton } from "@material-ui/lab";
import { AiFillRead } from "react-icons/ai";
import CreateAdCard from "./CreateAdCard";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { useMyContext } from "../../../contextApi/context";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

const useStyles = makeStyles((theme) => ({
  bookTitle: {
    fontSize: "30px",
    fontWeight: "500",
  },
  input: {
    padding: 15,
    borderRadius: "2px",
  },
  priceTag: {
    margin: 0,
  },
  addBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    fontSize: "12px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 0",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  toastBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    textDecoration: "none",
    marginLeft: "20px",
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  Description: {
    fontSize: "16px",
    lineHeight: 1.5,
    margin: "10px 0",
    whiteSpace: "pre-wrap", 
  },
  checkboxInput: {
    appearance: "none",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    border: `2px solid ${theme.palette.secondary.main}`,
    outline: "none",
    marginRight: theme.spacing(1),
    cursor: "pointer",
    position: "relative",
    transition: "border-color 0.2s ease-in-out",
    "&:checked": {
      borderColor: theme.palette.primary.main,
      "&::after": {
        content: '""',
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "10px",
        height: "10px",
        borderRadius: "50%",
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  checkboxLabel: {
    fontSize: "18px",
  },
  authorSection: {
    marginTop: "20px",
  },
  authorBiography: {
    whiteSpace: "pre-wrap", // Added this line for author biography
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start", // Align items at the top
    padding: theme.spacing(2),
    gap: theme.spacing(2), // Add space between image and content
  },
  content: {
    maxWidth: "700px",
    padding: theme.spacing(2),
  },
  imageContainer: {
    maxWidth: "300px",
    marginRight: theme.spacing(2), // Ensures equal spacing from the left
    alignSelf: "flex-start", // Align the image at the top
  },
}));

function BookDetail(props) {
  const {
    currentBook,
    wishlist,
    user,
    author,
    params,
    isDisable,
    setIsDisable,
  } = props;
  const classes = useStyles();
  const logInUser = user.user
    ? user.user.role //customer
    : user.author
    ? user.author.role //author
    : user.role; //member
  const [bookOrder, setBookOrder] = useState({});
  const history = useHistory();
  const [favorite, setFavorite] = useState(false);
  const [disableAddToCart, setDisableAddToCart] = useState(false);
  const [disableAddToWishlist, setDisableAddToWishlist] = useState(false);
  const [disableRemoveWishlist, setDisableRemoveWishlist] = useState(false);
  const { cartItems, setCartItems, setBook } = useMyContext();

  useEffect(() => {
    handleFetchCurrentBookOrder();
  }, []);

  useEffect(() => {
    if (wishlist) {
      let favorite = wishlist.book.find(
        (book) => book._id === currentBook?._id
      );
      if (favorite) {
        setFavorite(true);
      } else {
        setFavorite(false);
      }
    }
  }, [wishlist]);

  const addtoCart = (e) => {
    if (!disableAddToCart) {
      setDisableAddToCart(true);

      e.preventDefault();
      backend
        .post("/shopCart", {
          bookId: params.bookId,
          cartItemType: "BOOK",
          bookOrderType: "EBOOK",
        })
        .then((res) => {
          if (res.status === 200) {
            backend.get("/shopCart").then((response) => {
              setCartItems(response?.data?.data);
              setBook(response?.data);
              toast.success("Product has added to Cart");
              history.push("/shopping-cart");
            });
          }
        })
        .catch((error) => {
          toast.error(error.message);
        });
    }
  };

  const handleWishListAdd = () => {
    if (!disableAddToWishlist) {
      setDisableAddToWishlist(true);

      const newWishlist = {
        book: currentBook?._id,
        date_updated: new Date(),
      };
      backend
        .put(`/wishlist/${wishlist._id}`, newWishlist)
        .then((res) => {
          if (res.data.message === "Wishlist Record Updated") {
            toast.success("Book Added to Wishlist");
          }
          setFavorite(true);
        })
        .catch((err) => {
          let message = err.response ? err.response.data.message : err.message;
          toast.error(message);
        });
    }
  };

  const handleWishlistRemove = () => {
    if (!disableRemoveWishlist) {
      setDisableRemoveWishlist(true);
      const newWishlist = {
        book: currentBook?._id,
        date_updated: new Date(),
      };
      backend
        .put(`/wishlist/${wishlist._id}/remove`, newWishlist)
        .then((res) => {
          if (res.data.message === "Wishlist Record Updated") {
            toast.warn("Book removed from wishlist");
          }
          setFavorite(false);
        })
        .catch((err) => {
          let message = err.response ? err.response.data.message : err.message;
          toast.error(message);
        })
        .finally(() => {
          setDisableRemoveWishlist(false);
        });
    }
  };

  const handleFetchCurrentBookOrder = () => {
    backend
      .get(`/bookOrder?book=${currentBook?._id}&user=${user._id}`)
      .then((res) => {
        setBookOrder(
          res.data.data.find((order) => order.book_price.digital_price)
        );
      })
      .catch((err) => {
        let message = err.response ? err.response.data.message : err.message;
      });
  };

  const ToastBox = () => {
    return (
      <div>
        CART UPDATED
        <Link to="/cart" style={{ textDecoration: "none" }}>
          <Button
            variant="contained"
            className={classes.toastBtn}
            endIcon={<FaShoppingBasket />}
          >
            View Cart
          </Button>
        </Link>
      </div>
    );
  };

  return (
    <Box>
      {currentBook && author ? (
        <div className={classes.container}>
          <div className={classes.imageContainer}>
            <Zoom>
              <img
                src={currentBook?.book_cover}
                alt=""
                style={{ width: "100%", height: "auto", objectFit: "contain" }}
              />
            </Zoom>
          </div>
          <div className={classes.content}>
            <h1 className={classes.bookTitle}>{currentBook?.book_title}</h1>
            <p className={classes.Description} style={{ textAlign: "justify" }}>{currentBook?.book_story}</p>
            {currentBook?.price && (
              <Box>
                {currentBook?.price.digital_price && (
                  <div className={classes.checkboxContainer}>
                    <p style={{ fontWeight: "bold" }}>
                      Digital Ebook Price: {currentBook?.price.digital_price}$
                    </p>
                  </div>
                )}
              </Box>
            )}

            {logInUser && logInUser === "member" ? (
              <CreateAdCard book={currentBook} member={user} />
            ) : (
              <Grid container spacing={2}>
                {wishlist && (
                  <Grid item xs={12} md={6}>
                    {favorite ? (
                      <Button
                        className={classes.addBtn}
                        startIcon={<FaHeart />}
                        onClick={handleWishlistRemove}
                        fullWidth
                      >
                        Remove from Wishlist
                      </Button>
                    ) : (
                      <Button
                        className={classes.addBtn}
                        startIcon={<FaHeart />}
                        onClick={handleWishListAdd}
                        fullWidth
                      >
                        {disableAddToWishlist
                          ? "Adding to Wishlist"
                          : "Add to Wishlist"}
                      </Button>
                    )}
                  </Grid>
                )}
                {logInUser === "customer" && (
                  <Grid item xs={12} md={6}>
                    <Button
                      className={classes.addBtn}
                      startIcon={<FaShoppingBasket />}
                      onClick={addtoCart}
                      fullWidth
                      disabled={isDisable}
                    >
                      {isDisable
                        ? "Already in Cart"
                        : disableAddToCart
                        ? "Adding"
                        : "Add to Cart"}
                    </Button>
                  </Grid>
                )}
              </Grid>
            )}
            {currentBook?.book_category &&
              currentBook?.book_category?.length > 0 && (
                <p>
                  <span
                    className={classes.Description}
                    style={{ fontWeight: "bold" }}
                  >
                    Categories:{" "}
                  </span>
                  {currentBook?.book_category?.map((category, index) => (
                    <span key={index}>
                      {category.category_name}
                      {index < currentBook.book_category.length - 1 ? ", " : ""}
                    </span>
                  ))}
                </p>
              )}
            <h1 className={`${classes.bookTitle} ${classes.authorSection}`}>
              About the author
            </h1>
            <p className={`${classes.Description} ${classes.authorBiography}`} style={{ fontWeight: "bold" }}>
              <p>{author?.name}</p>
            </p>
            <p className={classes.authorBiography} style={{ textAlign: "justify" }}>{currentBook?.writer?.author_biography}</p>
          </div>
        </div>
      ) : (
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={5}>
              <Skeleton
                variant="rect"
                width="60%"
                height={450}
                style={{ margin: "0 auto" }}
                animation
              />
            </Grid>
            <Grid xs={12} sm={6} md={6} lg={7}>
              <Skeleton
                variant="rect"
                width="90%"
                height={100}
                animation="wave"
              />
              <Skeleton
                animation="wave"
                width="90%"
                style={{ marginTop: 40 }}
              />
              <Skeleton animation="wave" width="75%" />
              <Skeleton animation="wave" width="60%" />
              <Skeleton animation="wave" width="45%" />

              <Skeleton
                animation="wave"
                width={200}
                height={40}
                style={{ marginTop: 30 }}
              />
              <Skeleton animation="wave" width={200} height={40} />
              <Skeleton animation="wave" width={200} height={40} />

              <Box display="flex" mt={5}>
                <Skeleton
                  variant="rect"
                  width="40%"
                  height={40}
                  animation="wave"
                />
                <Skeleton
                  variant="rect"
                  width="40%"
                  height={40}
                  style={{ marginLeft: 20 }}
                  animation="wave"
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  );
}

export default BookDetail;
